export const MediaSource = () => {
  return <div>媒体资源 </div>;
};
